/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as UserRoleService} from "../../../Services/UserRoleService";

export class UserRoleFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			roles: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		UserRoleService.Get()
			.then((x) => {
				this.setState({roles: x.result});
			});
	}

	@autobind
	getRole() {
		return this.state.roles.find((x) => x.userRoleId == this.props.Value);
	}

	@autobind
	_render() {
		let role = this.getRole();

		return role ? role.name : "N/A";
	}
}